import { DndContext, DragEndEvent } from '@dnd-kit/core';
import React from "react";
import { NoAgendaItemsPanelMessage } from './AgendaItemPanel';
import { AgendaItem, PublicAmorgUser, agendaItemHelper } from "../../../amorg-common";
import { moveAgendaItemToIndex } from "../../../api/activityClientApi";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { AgendaItemPanel } from './AgendaItemPanel';
import { ActivityComponentProps } from './ActivityComponentProps';

export function AgendaItemListView (props: ActivityComponentProps & {onClickCreateAgendaItem: () => void}): JSX.Element
{
    return (
        <AgendaItemListPanel
            {...props}
            activityId={props.activity.id}
            agendaItems={props.activity.agendaItems}
            users={props.users}
            onUpdated={props.onActivityUpdated}
            onClickCreateAgendaItem={props.onClickCreateAgendaItem} />
    );
}

type AgendaItemListPanelProps = {
    activityId: string,
    agendaItems: AgendaItem[],
    users: PublicAmorgUser[],
    onUpdated: () => void,
    onClickCreateAgendaItem: () => void,
};
function AgendaItemListPanel (props: AgendaItemListPanelProps): JSX.Element
{
    const sorted = agendaItemHelper.getSortedAgendaItems(props.agendaItems);

    async function handleDragEnd(event: DragEndEvent)
    {
        const sourceId = event.active.id.toString().substring(7);
        const targetId = event.over?.id.toString().substring(7);

        if(!targetId || sourceId === targetId)
            return;

        const rootAgendaItems = sorted.filter(ai => ai.parentId === '');
        const sourceIndex = rootAgendaItems.findIndex(ai => ai.id === sourceId);
        const targetIndex = rootAgendaItems.findIndex(ai => ai.id === targetId);
        if(sourceIndex === -1 || targetIndex === -1)
            return;

        const result = await moveAgendaItemToIndex(sourceId, props.activityId, targetIndex);
        if(result.isSuccess)
            props.onUpdated();
    }

    return (

        <Flex gap={4} flexDirection="column">
    
            {sorted.length === 0 &&
                <NoAgendaItemsPanelMessage onClickCreateAgendaItem={props.onClickCreateAgendaItem} />
            }

            <DndContext onDragEnd={handleDragEnd}>
                <Flex flexDirection="column" gap={32}>
                    {sorted.map((ai,i) =>
                        <AgendaItemPanel key={ai.id}
                            activityId={props.activityId}
                            agendaItem={ai}
                            agendaItemIndex={i}
                            agendaItemsCount={props.agendaItems.length}
                            users={props.users}
                            isDragEnabled={ai.parentId === ''}
                            onUpdated={props.onUpdated} />
                    )}
                </Flex>
            </DndContext>
        </Flex>
    );
}